





















import AbpBase from '@/lib/abpbase'
import Util from '@/lib/util'
import { Component } from 'vue-property-decorator'
import PageRequest from '@/store/entities/page-request'
import Link from '@/store/entities/link'
import { EventBus } from '@/lib/eventbus';
@Component
export default class SelectCategory extends AbpBase {
    pagerequest:PageRequest=new PageRequest();
    collapseVal:string="2";
    link:Link = new Link();
    formValidate:any= {
        pickedVal:"",
    }
    add(){
        let pickedLink = this.list.filter(n=>n.simpleCategoryName==this.formValidate.pickedVal)[0];
        this.link.name = pickedLink.name;
        this.link.url = '/category/'+this.formValidate.pickedVal;
        this.link.target = "";
        this.link.external = false;
        this.create();
    }
    async create(){
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'links/create',
                    data:this.link
                }).then( () =>{
                    this.link = new Link();
                    EventBus.$emit('createMenuLink');
                    this.getpage();
                });
            }
        });
    }
    get list(){
        return this.$store.state.categorylist.list;
    }
    async getpage(){     
        await this.$store.dispatch({
            type:'categorylist/getAll',
            data:this.pagerequest
        })
    }
    async created(){
        this.getpage();
    }
    rules= {
        name: [
            { required: true, message: this.L('PleaseSelectCategory'), trigger: 'change'  }
        ],
    }
};
